<template>
  <div ref="chartBar" style="width: 100%; height: 100%"></div>
</template>

<script>
  import echarts from "./echarts";
  import resize from "@/utils/echartsResize";
  export default {
    name: "ChartBar",
    mixins: [resize],
    props: {
      chartData: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      this.chart = null;
      return {};
    },
    created() {},
    mounted() {
      this.init();
      this.$watch("chartData", (chartData) => {
        const { name, xAxisData = [], seriesData = [] } = chartData;
        this.chart &&
          this.chart.setOption({
            xAxis: {
              data: xAxisData,
            },
            series: [
              {
                name: name,
                data: seriesData,
              },
            ],
          });
      });
    },
    beforeDestroy() {
      // 销毁echarts实例
      this.chart && this.chart.dispose();
      this.chart = null;
    },
    methods: {
      init() {
        this.chart = echarts.init(this.$refs.chartBar);
        const { name, xAxisData = [], seriesData = [] } = this.chartData;
        const option = {
          grid: {
            containLabel: true,
            top: "10%",
            right: "0",
            bottom: "0",
            left: "0",
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          xAxis: {
            type: "category",
            data: xAxisData,
            axisLine: {
              lineStyle: { color: "rgba(255, 255, 255, 0.1)" },
            },
            axisTick: {
              show: false,
            },
            offset: 10,
            axisLabel: {
              fontSize: 12,
              interval: 0,
              color: "#ffffff",
              rotate: 20,
              align: 'center',
            },
          },
          yAxis: {
            axisLine: { show: false },
            axisTick: { show: false },
            axisLabel: {
              fontSize: 12,
              color: "rgba(255,255,255,0.6)",
            },
            splitLine: {
              lineStyle: { color: "rgba(255,255,255,0.2)", type: "dashed" },
            },
          },
          series: [
            {
              type: "bar",
              barWidth: "14",
              name: name,
              showBackground: true,
              backgroundStyle: {
                color: "rgba(255,255,255,0.1)",
              },
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#36EBCA" },
                  { offset: 1, color: "#1882FF" },
                ]),
              },
              emphasis: {
                itemStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: "#36EBCA" },
                    { offset: 1, color: "#1882FF" },
                  ]),
                },
              },
              data: seriesData,
            },
          ],
        };
        this.chart && this.chart.setOption(option);
      },
    },
  };
</script>

<style scoped lang="less"></style>
